import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import { Link } from 'react-router'
import {List, ListItem} from 'material-ui/List'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import { tenants } from 'selectors/entities'
import { householdTenants } from 'selectors/tenant'
import Section from 'components/Section'
import TenantCard from './TenantCard'

let select = dirtyRead(
	(state, props) => ({
		tenant: doc(state, props.objectID)
	  , householdTenants: householdTenants(state, props)
	})
)

export class Household extends Component{
	render(){
		let { props } = this
		return(
			<Section
				id="tenant/household"
				title="Household"
			>
				<List
					style={{
						backgroundColor: "transparent"
						, paddingTop: "0"
					}}
				>
					{props.householdTenants.length > 1 &&
						<div>
							<TenantCard objectID={props.tenant.parentID || props.objectID} bold={true} />
							{props.householdTenants.map(tenant =>
								tenant._id != (props.tenant.parentID || props.objectID)
								&& <TenantCard objectID={tenant._id} />
							)}
						</div>
					}
				</List>
            </Section>
		)
	}
}

export default connect(select, dataActions)(Household)



// WEBPACK FOOTER //
// ./src/routes/manager/tenantForm/Household.js